import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-made-it-home-safely-slide',
  templateUrl: './made-it-home-safely-slide.component.html',
  styleUrl: './made-it-home-safely-slide.component.scss'
})
export class MadeItHomeSafelySlideComponent implements OnInit{
  constructor() {}

  ngOnInit(): void {}

}
